import { render } from "./SubmitRetailerBox.vue?vue&type=template&id=17af7ed2"
import script from "./SubmitRetailerBox.vue?vue&type=script&lang=js"
export * from "./SubmitRetailerBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__